import { BaseInterfaceElement, DOMContainerType, } from '@vendor/libs/maps/interface-elements/base';
import { Dropdown } from 'bootstrap';
import { i18n } from '@vendor/libs/lang/lang';
import Legend from 'ol-ext/legend/Legend';
export class LegendInterfaceElement extends BaseInterfaceElement {
    constructor(options) {
        super('legend', options);
    }
    renderLegend(button) {
        const customMap = this.customMap;
        if (!customMap) {
            return;
        }
        const table = $(`
        <table class="table table-sm">
        <tbody>
        </tbody>
        </table>
    `);
        button.find('ul li').empty().append(`
        <label class="form-label">${i18n.trans('map.interface_elements.legend.title')}</label><br>
        <div style="max-height: 380px; overflow: auto;"></div>
    `);
        button.find('ul li div').append(table);
        let addedItems = new Set();
        for (const name in customMap.features) {
            for (const legendItem of customMap.features[name].getLegendItems()) {
                if (!addedItems.has(legendItem.title)) {
                    const row = $(`<tr><td class="d-flex"></td><td>${legendItem.title}</td></tr>`);
                    row
                        .find('td:first')
                        .append(LegendInterfaceElement.createLegendItem(legendItem.style, legendItem.geomType));
                    table.append(row);
                    addedItems.add(legendItem.title);
                }
            }
        }
    }
    _handle(customMap, id) {
        super._handle(customMap, id);
        const _ = this;
        const button = this.addDOM($(`
        <div class="ol-control position-static dropend" style="border-top-left-radius: 0; border-top-right-radius: 0">
          <button class="user-select-none" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" style="border-top-left-radius: 0; border-top-right-radius: 0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="18" width="18">
              <path xmlns="http://www.w3.org/2000/svg" d="M8.7 4.19995L4 6.30005V18.8999L8.7 16.8V19L3.1 21.5C2.6 21.7 2 21.4 2 20.8V6C2 5.4 2.3 4.89995 2.9 4.69995L8.7 2.09998V4.19995Z" fill="currentColor"></path>
              <path xmlns="http://www.w3.org/2000/svg" d="M15.3 19.8L20 17.6999V5.09992L15.3 7.19989V4.99994L20.9 2.49994C21.4 2.29994 22 2.59989 22 3.19989V17.9999C22 18.5999 21.7 19.1 21.1 19.3L15.3 21.8998V19.8Z" fill="currentColor"></path>
              <path xmlns="http://www.w3.org/2000/svg" opacity="0.3" d="M15.3 7.19995L20 5.09998V17.7L15.3 19.8V7.19995Z" fill="currentColor"></path>
              <path xmlns="http://www.w3.org/2000/svg" opacity="0.3" d="M8.70001 4.19995V2L15.4 5V7.19995L8.70001 4.19995ZM8.70001 16.8V19L15.4 22V19.8L8.70001 16.8Z" fill="currentColor"></path>
              <path xmlns="http://www.w3.org/2000/svg" opacity="0.3" d="M8.7 16.8L4 18.8999V6.30005L8.7 4.19995V16.8Z" fill="currentColor"></path>
            </svg>
          </button>
          <ul class="dropdown-menu" style="width: 350px;">
            <li class="px-2">
            </li>
          </ul>
        </div>`), DOMContainerType.MAP_TOP_LEFT);
        new Dropdown(button[0]);
        button.on('show.bs.dropdown', () => {
            this.renderLegend(button);
        });
    }
    static createLegendItem(style, geom) {
        return Legend.getLegendImage({ typeGeom: geom, style });
    }
}
